import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ASSETS } from '../config/assets';
export function SubPageHeader({ title, badge, onGoHome, onClose }) {
    return (_jsxs("div", { style: {
            height: 50,
            flex: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '0 14px',
            background: '#FFFFFF',
            borderBottom: '1px solid #E2E8F0',
        }, children: [_jsxs("button", { type: "button", onClick: onGoHome, title: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D", className: "kp-home-link", style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    textDecoration: 'none',
                    color: 'inherit',
                    border: 'none',
                    borderRadius: 8,
                    padding: '2px 6px',
                    marginLeft: -6,
                    background: 'none',
                    cursor: 'pointer',
                }, children: [_jsx("img", { src: ASSETS.logo, alt: "", style: { width: 28, height: 28 } }), _jsx("span", { style: { fontSize: 14.5, fontWeight: 700, letterSpacing: '-0.01em' }, children: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u043D" })] }), _jsx("div", { style: { width: 1, height: 20, background: '#E2E8F0' } }), _jsx("div", { style: { fontSize: 13.5, color: '#475569' }, children: title }), badge ? (_jsx("div", { style: {
                    fontSize: 11,
                    fontWeight: 600,
                    padding: '2px 8px',
                    borderRadius: 999,
                    background: '#F1F5F9',
                    color: '#94A3B8',
                }, children: badge })) : null, _jsx("button", { type: "button", onClick: onClose, className: "kp-back-btn", style: {
                    marginLeft: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    height: 32,
                    padding: '0 12px',
                    border: '1px solid #CBD5E1',
                    borderRadius: 8,
                    background: '#FFFFFF',
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: '#334155',
                    cursor: 'pointer',
                }, children: "\u2190 \u041A \u043F\u043B\u0430\u043D\u0443" })] }));
}
